module.exports = __webpack_public_path__ + "static/two-31b10ac21440eb96c382bf930bb27018.png";